import * as types from './constants';

// Get Code Details
export const getCodeDetailsRequest = data => (
  { type: types.GET_CODE_DETAILS_REQUEST, payload: data }
);

export const getCodeDetailsDone = data => (
  { type: types.GET_CODE_DETAILS_DONE, payload: data }
);

export const getCodeDetailsFailed = errors => (
  { type: types.GET_CODE_DETAILS_FAILED, payload: errors }
);